import { apiConstants } from '../_constants';
import { authHeader, handleResponse, logout } from '../_helpers';

export const userService = {
  login,
  logout,
  getOtp,
  verifyOtp,
  saveUser,
  usersList
};

function login(data) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  };

  return fetch(apiConstants.apiUrl + '/login', requestOptions)
    .then(handleResponse)
    .then((user) => {
      // login successful if there's a jwt token in the response
      if (user.data.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user.data));
      }

      return user;
    });
}


async function getOtp(phone) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ phone }),
  };

  return fetch(apiConstants.apiUrl + "/generateotp", requestOptions).then(
    handleResponse
  );
}

function verifyOtp(phone, otp) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ phone, otp }),
  };

  return fetch(apiConstants.apiUrl + "/verifyotplogin", requestOptions)
    .then(handleResponse)
    .then(async (user) => {

      // login successful if there's a jwt token in the response
      if (user.data.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user.data));
      }

      return user;
    });
}


async function saveUser(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(apiConstants.apiUrl + "/adduser", requestOptions)
    .then(handleResponse)
    .then(async (user) => {
      // login successful if there's a jwt token in the response
      if (user.data.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user.data));
      }
      return user;
    });
}
function usersList(data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };
  return fetch(apiConstants.apiUrl + "/getuserlist", requestOptions).then(
    handleResponse
  );
}
